export * from './TransferSmallIcon'
